export default __webpack_public_path__ + "static/media/Coils of the Brood.31b3a5b5.jpg";